import { Answer, InternetServiceSelection } from 'types/Internet';

const carrierButtons: Answer[] = [
  {
    index: 4,
    answerText: 'LG U+',
  },
  {
    index: 3,
    answerText: 'SK 브로드밴드',
  },
  {
    index: 2,
    answerText: 'KT',
  },
];

const productButtons: Answer[] = [
  {
    index: 2,
    answerText: '인터넷',
    priceComparison: '',
  },
  {
    index: 3,
    answerText: '인터넷+TV',
    priceComparison: '',
  },
  {
    index: 4,
    answerText: '인터넷+TV+\n집 전화',
    priceComparison: '',
  },
];

const speedButtons: Answer[] = [
  {
    index: 2,
    answerText: '100mb',
    detail: '1~2인 가구\n대부분 가능\n(영상포함)',
    priceComparison: '',
  },
  {
    index: 3,
    answerText: '500mb',
    detail: '게임을 즐기는\n2~4인 가구',
    priceComparison: '+ 월 2,000원',
  },
  {
    index: 4,
    answerText: '1GB',
    detail: '인터넷 방송 등\n전문 작업',
    priceComparison: '+ 월 3,000원',
  },
];

const existButtons: InternetServiceSelection[] = [
  {
    index: 1,
    answerText: '신규 가입',
    desc: {
      isAlert: false,
      title: '신규 가입이 필요하세요?',
      description: '현재 사용중인 인터넷이 없어서 새롭게 인터넷을 가입하는 거에요.',
    },
  },
  {
    index: 2,
    answerText: '통신사 변경',
    desc: {
      isAlert: false,
      title: '통신사 변경이 필요하세요?',
      description: '현재 사용중인 통신사에서 다른 통신사로 변경하는 거에요. 예시) KT > LGU+',
    },
  },
  {
    index: 3,
    answerText: '재약정',
    desc: {
      isAlert: true,
      title: '재약정은 미소에서 할 수 없어요',
      description: '현재 이용중인 통신사와 약정하는 거에요. 필요 시 해당 통신사에 문의해 보세요.',
    },
  },
  {
    index: 4,
    answerText: '이전 설치',
    desc: {
      isAlert: true,
      title: '이전 설치는 미소에서 할 수 없어요',
      description: '사용 중인 인터넷을 이사 갈 집에 그대로 옮기는 거에요. 필요 시 통신사에 문의해 보세요.',
    },
  },
];

const equalButtons: Answer[] = [
  {
    index: 2,
    answerText: '결합 할인 적용',
  },
  {
    index: 1,
    answerText: '적용 안 함',
  },
];

export { carrierButtons, productButtons, speedButtons, existButtons, equalButtons };
